enum PaymentMethod {
    CASH = "CASH",
    BANK_TRANSFER = "BANK_TRANSFER",
    CHECK = "CHECK",
    CREDIT_CARD = "CREDIT_CARD",
    DEBIT_CARD = "DEBIT_CARD",
    ZELLE = "ZELLE",
    OTHER = "OTHER",
}

export default PaymentMethod;